var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversalMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 67,
    viewBox: "0 0 72 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71.7736,
    height: 67,
    rx: 17.5738,
    fill: "#F7F6F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7494 27.2566C31.4095 27.2566 31.9422 27.7882 31.9422 28.4418L31.9422 42.5183C31.9422 43.1712 31.4094 43.7034 30.7494 43.7034C30.0893 43.7034 29.5565 43.1712 29.5565 42.5183L29.5565 28.4426C29.5565 27.7888 30.0894 27.2566 30.7494 27.2566Z",
    fill: "url(#paint0_linear_7153_14225)",
    stroke: "#187C85",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.111 23.2969L36.1608 23.2969C36.863 23.3262 37.4695 23.9719 37.4695 24.826L37.4695 42.1732C37.4695 43.0466 36.834 43.7034 36.111 43.7034C35.3881 43.7034 34.7525 43.0466 34.7525 42.1732L34.7525 24.8271C34.7525 23.9528 35.388 23.2969 36.111 23.2969Z",
    fill: "url(#paint1_linear_7153_14225)",
    stroke: "#187C85",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6384 21.0857L41.6869 21.0857C42.3659 21.1178 42.9969 21.8201 42.9969 22.8074L42.9969 41.9806C42.9969 42.9903 42.3355 43.7034 41.6384 43.7034C40.9413 43.7034 40.2799 42.9903 40.2799 41.9806L40.2799 22.8085C40.2799 21.7978 40.9412 21.0857 41.6384 21.0857Z",
    fill: "url(#paint2_linear_7153_14225)",
    stroke: "#187C85",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.832 24.1016V46.2148H46.9453",
    stroke: "#187C85",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7153_14225",
    x1: 37.3774,
    y1: 23.0769,
    x2: 31.9256,
    y2: 42.4434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7153_14225",
    x1: 43.4746,
    y1: 18.2146,
    x2: 36.1461,
    y2: 41.6839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7153_14225",
    x1: 49.002,
    y1: 15.5,
    x2: 40.2223,
    y2: 40.9389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversalMenuIcon);
export default __webpack_public_path__ + "static/media/universal-menu-icon.e63fc1bd93accaafb9ea578e697bafd3.svg";
export { ForwardRef as ReactComponent };